import { Button, IconArrowUpRight, Link } from '@sequencehq/core-components'
import { getPortalDomain } from '@sequencehq/utils'
import { getEnvironment } from 'lib/environment/environment.ts'

type Props = {
  path: string
  isDisabled?: boolean
}

export const ViewCustomerPortalButton = ({
  path,
  isDisabled = false
}: Props) => {
  const portalDomain = getPortalDomain(getEnvironment())
  const customerPortalHref = !isDisabled ? `${portalDomain}${path}` : '#'

  return (
    <Link
      to={customerPortalHref}
      target="_blank"
      aria-label="View customer portal"
    >
      <Button
        variant="secondary"
        leadingIcon={<IconArrowUpRight />}
        disabled={isDisabled}
      >
        View customer portal
      </Button>
    </Link>
  )
}
